import { shallowEqual } from 'react-redux';

import { useAppSelector } from '@/features/hooks';
import { rootSelectors } from '@/features/store';
import { IExtendedBenefitsData, IExtendedMaxBenefit } from '@/interfaces/cars.interfaces';

/**
 * Возвращает список выгод, выбранных пользователем.
 * Если пользователь еще ничего не выбрал, выбранными должны быть те выгоды, что указаны в максимальных.
 * @param carId идентификатор автомобиля
 * @param benefits список всех выгод
 * @param maxBenefit список максимальных выгод
 * @returns выбранные выгод
 */
export default function useBenefitsChoice(
  carId?: string,
  benefits?: Array<IExtendedBenefitsData>,
  maxBenefit?: Array<IExtendedMaxBenefit>,
): Array<IExtendedBenefitsData> {
  const benefitsChoice = useAppSelector(state => {
    if (!carId || !benefits) {
      return [];
    }

    const benefitsChoice = rootSelectors.benefitsChoice.selectById(
      state.benefitsChoice,
      carId,
    );
    if (benefitsChoice) {
      return benefitsChoice.benefits;
    }

    // Если объект benefitsChoice не существует, это означает, что пользователь еще
    // не взаимодействовал со списком выгод, в данном случае считаются выбранными те
    // пункты, что дают максимальную выгоду
    if (maxBenefit) {
      return benefits.filter(benefit =>
        maxBenefit.some(maxBenefit => maxBenefit.id === benefit.id),
      );
    }

    // Если максимальные выгоды не указаны, то ни один элемент не будет выбран.
    return [];
  }, shallowEqual);

  return benefitsChoice;
}
